import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ApiService } from './api.service';
import { ApiV1Service } from './apiv1.service';
import { OpenAPIFileService } from './openApi-file.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule],
  providers: [ApiService, ApiV1Service, OpenAPIFileService]
})
export class ApiModule {}
